import { NgModule } from '@angular/core';
import BasisDetailsComponent from './basis-details.component';
import PinBasisDetailsButtonComponent from './pin-basis-details-button/pin-basis-details-button.component';
import OrderBuyButtonComponent from './order-buy-button/order-buy-button.component';
import SectionInfoComponent from './section-info/section-info.component';
import { CommonModule, DatePipe } from '@angular/common';
import SectionButtonComponent from './section-button/section-button.component';
import InfoItemComponent from './section-info/info-item/info-item.component';
import { LastDealsTableContainer } from './last-deals/last-deals-table.container';
import { LastDealsTableComponent } from './last-deals/last-deals-table.component';
import { LastDealsHeaderContainer } from './last-deals/header/last-deals-header.container';
import { LastDealsHeaderComponent } from './last-deals/header/last-deals-header.component';
import { LastDealsContentContainer } from './last-deals/content/last-deals-content.container';
import { LastDealsContentComponent } from './last-deals/content/last-deals-content.component';
import { NumberFormatModule } from '@prlw/libs/number-format/number-format.module';
import { DeliveryTimeGraphComponent } from './delivery-time-graph/delivery-time-graph.component';
import { DeliveryTimeGraphTooltipComponent } from './delivery-time-graph/delivery-time-graph-tooltip.component';
import GraphRadioGroupComponent from './graph-radio-group/graph-radio-group.component';
import { NgChartsModule } from 'ng2-charts';
import { PriceHistoryGraphComponent } from './price-history-graph/price-history-graph.component';
import { PriceHistoryGraphTooltipComponent } from './price-history-graph/price-history-graph-tooltip.component';
import { IconsModule } from '@prlw/libs/icons/icons.module';
import BasisManufacturerLabelComponent from './basis-manufacturer-label/basis-manufacturer-label.component';
import { SharedModule } from 'src/app/features/shared/shared.module';
import { ResponsiveDirective } from '@prlw/libs/responsive/responsive.directive';
import { MarketDepthComponent } from './market-depth/market-depth.component';
import { ScrollAnchorDirective } from '@prlw/libs/scroll-anchor/scroll-anchor.directive';
import { ScrollAnchorMenuDirective } from '@prlw/libs/scroll-anchor/scroll-anchor-menu.directive';
import { TwPriceHistoryChartComponent } from './tw-price-history-chart/tw-price-history-chart.component';
import { LastDealsTableHeaderRowContainer } from './last-deals/table-header-row/last-deals-table-header-row.container';
import { LastDealsTableHeaderRowComponent } from './last-deals/table-header-row/last-deals-table-header-row.component';
import { SyncScrollModule } from '@prlw/libs/sync-scroll/sync-scroll.module';
import { TextTagOtpComponent } from '../../text-tag-otp/text-tag-otp.component';
import { LastDealsFetchMoreButtonComponent } from './last-deals/fetch-more-button/last-deals-fetch-more-button.component';

@NgModule({
  imports: [
    CommonModule,
    NumberFormatModule,
    NgChartsModule,
    IconsModule,
    SharedModule,
    ResponsiveDirective,
    MarketDepthComponent,
    ScrollAnchorDirective,
    ScrollAnchorMenuDirective,
    TwPriceHistoryChartComponent,
    SyncScrollModule,
    TextTagOtpComponent,
  ],
  declarations: [
    BasisDetailsComponent,
    PinBasisDetailsButtonComponent,
    OrderBuyButtonComponent,
    SectionButtonComponent,
    SectionInfoComponent,
    InfoItemComponent,
    GraphRadioGroupComponent,
    PriceHistoryGraphComponent,
    PriceHistoryGraphTooltipComponent,
    DeliveryTimeGraphComponent,
    DeliveryTimeGraphTooltipComponent,
    LastDealsContentContainer,
    LastDealsContentComponent,
    LastDealsTableContainer,
    LastDealsTableComponent,
    LastDealsHeaderContainer,
    LastDealsHeaderComponent,
    LastDealsTableHeaderRowComponent,
    LastDealsTableHeaderRowContainer,
    LastDealsFetchMoreButtonComponent,
    BasisManufacturerLabelComponent,
  ],
  providers: [DatePipe],
  exports: [BasisDetailsComponent],
})
export class BasisDetailsModule {}
